module.exports = __webpack_public_path__ + "static/media/module-program-card-banner-stabilization-endurance@2x.0d576b09.png";